import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/ta/account')({
  ssr: false,
});
